import { QUARTERS } from "constant/variables";
import React from "react";
import { Label, Input } from "reactstrap";

const QuartersDropdown = ({
  value,
  onChange,
  label = "Quarter",
  className = '',
}) => {
  return (
    <div className={`${className}`}>
      <Label>{label}</Label>
      <Input
        type="select"
        name="select"
        className="form-control digits uiStyleDashboard"
        value={value}
        onChange={onChange}
      >
        {QUARTERS.map((option) => (
          <option value={option.value}>{option.label}</option>
        ))}
      </Input>
    </div>
  );
};

export default QuartersDropdown;
